<template>
	<div v-if="!loading && model" :key="$route.params.id">
    <div v-if="model && model.deleted" class="alert alert-danger">
      <p class=""> <b> ATTENZIONE</b> Questo Motore è un motore eliminato. Le modifiche che apporti non saranno visibili</p>
    </div>
		<h2 class="page-title">
			<router-link :to="`/sites/${$route.params.siteId}`">
    			<i class="icon-minimal-left tim-icons" />
			</router-link>
			{{model.name}} <span v-if="site"> - {{site.name}}</span>
		</h2>
    <div class="row">
      <div class="col-12 col-xl-4">
        <card>
          <engine-form :model="model" :on-submit="addEngineSubmit"></engine-form>
        </card>
      </div>
      <div class="col-12 col-xl-8">
        <engine-attachments :engine="model" />
      </div>
      <div class="col-12">
        <engine-revisions-list
          v-if="revisions"
          :revisions="revisions"
          :site="site"
          :engine="model" />
      	<loading v-else />

      </div>
      <div class="col-12 text-right">
        <base-button type="danger" size="sm" @click="deleteEngine()">
					<i class="tim-icons icon-trash-simple"></i>
          elimina
        </base-button>
        
      </div>
    </div>
    
	</div>
	<loading v-else />
</template>
<script>
import EngineForm from '@/components/Engines/EngineForm.vue'
import EngineAttachments from '@/components/Engines/EngineAttachments.vue'
import EngineRevisionsList from '@/components/Revisions/EngineRevisionsList.vue'

import { mapState, mapActions } from 'vuex'


export default{
  computed: {
    ...mapState({
      revisions: state => state.revisions.revisions.docs,
      site: state => state.sites.site,
      model: state => state.engines.engine,
		  loading: state => state.engines.loading,
    })
  },
  mounted () {
    this.init(this.$route.params)
  },
  // QUesto codice può creare diversi problemi di performance. 
  beforeRouteUpdate (to,from,next) {
    this.init(to.params)
    next()
  },
  components: {
    EngineForm,
    EngineAttachments,
    EngineRevisionsList
  },
  methods: {
    ...mapActions('engines', {
      get: 'get',
      update: 'update',
      delete: 'delete',
    }),
    ...mapActions('revisions', {
      getRevisions: 'getAll',
    }),
    ...mapActions('sites', {
      getClient: 'get'
    }),
    init(params) {
      this.get({
        siteId: params.siteId,
        id: params.id
      });
      this.getClient(params.siteId);
      this.getRevisions({
        engineId: params.id,
        populate: 'author,finalRevision,attachments'
      })
    },
    addEngineSubmit() {
    	this.update(this.model)
    },
    async deleteEngine() {
      const res = await this.delete(this.$route.params);
      // torno all'engine. se l'engine è undefined torno all'homepage
      if (this.$route.params.siteId && this.$route.params.siteId !== "undefined" ){
        this.$router.push(`/sites/${this.$route.params.siteId}`)
      } else {
        this.$router.push(`/`)
      }
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
  },
}	
</script>